import React, { ReactNode } from 'react';
import { Header } from '../Header/Header';
import { AdSenseRail } from '../Ads/AdSenseRail';
import { CalculatorParams, AnalysisResponse } from '../../types/api';

interface MainLayoutProps {
  children: ReactNode;
  currentParameters?: CalculatorParams;
  currentAnalysisResult?: AnalysisResponse;
  onLoadAnalysis?: (parameters: CalculatorParams) => void;
  onOpenTutorial?: () => void;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ 
  children, 
  currentParameters, 
  currentAnalysisResult, 
  onLoadAnalysis,
  onOpenTutorial
}) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header 
        currentParameters={currentParameters}
        currentAnalysisResult={currentAnalysisResult}
        onLoadAnalysis={onLoadAnalysis}
        onOpenTutorial={onOpenTutorial}
      />

      <main className="flex-1">
        <div className="h-full p-6">
          {/* Main content grid with ad rail */}
          <div className="flex gap-6 h-full min-h-[calc(100vh-140px)]">
            {/* Main content */}
            <div className="flex-1">
              <div className="grid grid-cols-12 gap-6 h-full">
                {children}
              </div>
            </div>
            
            {/* Ad rail - only visible on large screens */}
            <AdSenseRail />
          </div>
        </div>
      </main>
    </div>
  );
};
